import {
  withTranslation,
} from 'react-i18next';

import RegattaMessageFieldsView from './RegattaMessageFieldsView';

const TranslatedComponent = withTranslation()(RegattaMessageFieldsView);

const Component = TranslatedComponent;

export default Component;
